module.exports = __webpack_public_path__ + "r-v3/img/out_white.7ad7e5da.svg";